<label *ngIf="label" class="col-form-label label-common">{{label}}<span class="text-danger">{{required ? ' *' : ''}}</span>
  <button *ngIf="tooltipLabel" trigger="focus" class="btn btn-link space-tooltip" tooltip="{{tooltipLabel}}"><i class="icon-info icons"></i>
  </button>
</label>
  <div [ngClass]="{'border-red': required && parentControl && parentControl.invalid && parentControl.touched}">
    <div >
      <angular2-multiselect [data]="dropdownList"
                            [id]="selectId"
                            [(ngModel)]="selectedItems"
                            [settings]="dropdownSettings"
                            [loading] = "loading"
                            [formControl]="inputControl"
                            (onScrollToEnd)="fetchMore($event)"
                            (onSelect)="onItemSelect($event)"
                            (onDeSelect)="OnItemDeSelect($event)"
                            (onSelectAll)="onSelectAll($event)"
                            (onDeSelectAll)="onDeSelectAll($event)"
                            (onSearch)="onSearch($event)">
      </angular2-multiselect>
    </div>

  </div>
  <div class="invalid-feedback" [attr.id]="selectId +'-invalid'"
       *ngIf="parentControl && parentControl.touched && parentControl.invalid && validationMessage">
    {{validationMessage}}
  </div>
